import $ from 'jquery';

// check is JS--hasContext
// Si non, afficher
// Si Oui, awt appelle contextualMenu ou event

const contextualMenu = function (contextualMenuData) {
    try {
        // if the DOM is not ready, then saves the requested data on the queue, to be executed later
        if (contextualMenuData != null) {
            var keysToCheck = Object.keys(contextualMenuData);
            var $contextualMenus = $('.contextualMenu');

            $contextualMenus.each(function (index, contextualMenu) {
                var $contextualMenu = $(contextualMenu);
                var $links = $contextualMenu.children('li');

                $links.each(function (i, link) {
                    var $link = $(link);

                    if ($link.hasClass("js--hasContext")) {
                        // if the link has context, we will check if we show it or remove it
                        var isValid = false;
                        var linkIdContext = $link.attr('data-idaction');

                        for (var j = 0; j < keysToCheck.length && !isValid; j++) {
                            if (linkIdContext == keysToCheck[j]) {
                                var $anchor = $link.children('a').first();
                                $anchor.attr("href", contextualMenuData[linkIdContext]);
                                isValid = true;
                            }
                        }
                        if (isValid) {
                            $link.show();
                        } else {
                            $link.hide();
                        }
                    } else {
                        // this is for the case when we are in mobile and links that exceed the limit of 10 are hidden:
                        // when we call the contextual menu function again, they must be shownm and hidden below if needed
                        // (if they exceed the limit of 10)
                        $link.show();
                    }
                });

                // if it's the mobile contextual menu, let's do the cleanups for mobile
                if($contextualMenu.hasClass("dcw_contextual-menu-mobile_list")){
                    // we will check only the links that don't have the 'js--hasContext' class, because:
                    // 1. if this method is called before the contextualMenu(), then we will remove the showing links exceeding the limit
                    // 2. if this method is called after the contextualMenu(), no link will have the class 'js--hasContext'
                    // This is to ensure that, if this method gets called twice (one before and another after the call of contextualMenu()),
                    // this won't remove too much links, leaving us with less then the maximum
                    $links = $contextualMenu.children('li:visible');
                    var plusButton = $(".dcw_contextual-menu-mobile_btn");

                    if($links.length === 0){
                        // if we don't have any link, we will hide the opening button
                        plusButton.addClass("dcw_visually-hidden");
                    } else {
                        // if we have some link, we will make sure the opening button will be shown
                        plusButton.removeClass("dcw_visually-hidden");

                        // if we have more than 7 links, then we need to add a special class
                        if ($links.length > 7) {
                            $contextualMenu.closest(".dcw_contextual-menu-mobile").addClass("dcw_contextual-menu-mobile--large");
                        } else {
                            $contextualMenu.closest(".dcw_contextual-menu-mobile").removeClass("dcw_contextual-menu-mobile--large");
                        }

                        // 10 is the maximum: if we have more than 10 links, we will remove the rest
                        $links.each(function (i, link) {
                            if(i < 10){
                                $(link).show();
                            } else {
                                $(link).hide();
                            }
                        });
                    }
                } else if($contextualMenu.hasClass("dcw_contextual-menu_wrapper")){
                    // if it's the right column desktop contextual menu, let's do the cleanups for that

                    $links = $contextualMenu.children('li:visible');
                    var $contextualMenuWrapper = $contextualMenu.closest(".rightColumnContextualMenuWrapper");

                    if($links.length === 0){
                        // if we don't have any link, we will hide the component
                        $contextualMenuWrapper.addClass("dcw_visually-hidden");
                    } else {
                        // if we have some link, we will make sure the opening button will be shown
                        $contextualMenuWrapper.removeClass("dcw_visually-hidden");
                    }
                }
            });
        }

        return true;
    } catch (error) {
        return false;
    }
};

module.exports = contextualMenu;


// WEBPACK FOOTER //
// ./src/js/cms/contextual-menu.js